<template>
  <fieldset class="mb-4" v-if="mainConfig.showInterests">
    <legend>{{ $t("Interests") }}</legend>
    <div class="row">
      <div class="col-sm-12 col-md">
        <div v-if="interests.data.length" class="ta-checkbox-list">
          <div class="row">
            <div class="col-md-4" v-for="interest of interests.data" :key="interest.key">
              <b-form-checkbox
                v-model="selected[interest.key]"
                @change="onCheckboxChange(interest)">
                {{ interest.name | currentLocale }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import BaseInputMixin from "../../../mixins/profileInputMixin";
import InputWidget from "../../core/InputWidget";

import {mapState, mapActions} from 'vuex';

export default {
  name: "InterestCheckboxes",
  components: {InputWidget},
  mixins: [BaseInputMixin('department_interests')],

  data() {
    return {
      defaultLabel: this.$t("Interests"),
      selected: {}
    }
  },
  computed: {
    ...mapState(['interests', 'mainConfig'])
  },
  methods: {
    ...mapActions(['getInterests']),
    onCheckboxChange(interest) {
      const selected = Object.fromEntries(Object.entries(this.selected).filter(([key, value]) => value));
      this.onInput([...Object.keys(selected)]);
    },
    updateSelected() {
      if (this.model) {
        if (Array.isArray(this.model)) {
          this.model.forEach(v => this.selected[v] = true);
          console.log(this.selected)

          if (this.model.length === 0) {
            for (let key in this.selected) {
              this.selected[key] = false;
            }
          }
          this.selected = {...this.selected};
        } else {
          this.selected = {
            [this.model]: true
          }
        }
      }
    }
  },
  watch: {
    model() {
      this.updateSelected()
    }
  },
  mounted() {
    this.getInterests();
    this.updateSelected();
  }
}
</script>

<style scoped>

</style>
